import { render, staticRenderFns } from "./EmailIntegracoes.vue?vue&type=template&id=720ce06c&scoped=true&"
import script from "./EmailIntegracoes.vue?vue&type=script&lang=js&"
export * from "./EmailIntegracoes.vue?vue&type=script&lang=js&"
import style0 from "./EmailIntegracoes.vue?vue&type=style&index=0&id=720ce06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720ce06c",
  null
  
)

export default component.exports